import axios from "axios";
import {DEFAULT_ERROR_TITLE, ERROR_SESSION_EXPIRED, ERROR_BAD_SESSION, INCORRECT_LOGIN_TYPE, API_OK, API_URL } from './Constants';
import { logout, verifyEmail, userToken } from "./features/user";
import { setLoading, setNavIndex } from "./features/common";
import cookie from "js-cookie";


export const checkApiSessionErrorMessage = (errorMessages, dispatch, navigate, isProvider=false) => {
    const sessionErrors = [
        ERROR_SESSION_EXPIRED,
        ERROR_BAD_SESSION,
        INCORRECT_LOGIN_TYPE
    ];

    if(sessionErrors.includes(errorMessages)
        && (logout !== null)){
        if((errorMessages !== ERROR_SESSION_EXPIRED) && (errorMessages !== INCORRECT_LOGIN_TYPE) && (typeof errorMessages !== 'undefined')){
            cookie.set('logout_error', errorMessages, { sameSite: 'strict' });
        }
        
        dispatch(logout());
        navigate("/", { replace: true });
    }else if(errorMessages.includes('Email not validated')) {
        dispatch(verifyEmail({token : userToken()}));
        navigate(isProvider?"/verify-provider-email":"/verify-email", { replace: true });
    } else {
        return false;
    }
    return true;
}

export const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
);

export const displayMinutes = (minutes) => {
    const minutesPart = Math.floor(minutes);
    let secondsPart = Math.round(minutes * 60 % 60);
    if(minutesPart ===0 && secondsPart === 0) {
        secondsPart = 1;
    }
    secondsPart = secondsPart < 10 ? `0${secondsPart}` : secondsPart;
    return `${minutesPart}:${secondsPart}`;
}

export async function checkValidToken(navigate, dispatch, forward = true, invalidLogout = true, invalidForward = null, altForward = '/home') {
    dispatch(setLoading({loading : true}));

    if(await checkIsTokenValid()) {
        if(forward) {
            let redirectFrom = cookie.get('redirect_from');
            if(redirectFrom){
                window.setTimeout(function(){
                    window.location.href = redirectFrom+"?token="+cookie.get('token');
                }, 3000);
            } else {
               navigate(altForward);
                //return;
            }
        }
    } else {
        if(cookie.get('token') && invalidLogout) {
            dispatch(logout());
        }
        if(invalidForward) {
            navigate(invalidForward);
            //return;
        }
    };

    dispatch(setLoading({loading : false}));
}

export function userLoggedIn(isLoggedIn, isVerifyEmail, navigate, dispatch) {
    if(isVerifyEmail) {
        // navigate( '/verify-email');
        navigateTo(dispatch, navigate, '/verify-email');
    }
    return isLoggedIn;
}


export async function showLoading(dispatch, show) {
    dispatch(setLoading({loading : show}));
}

export async function setLoadingShow(dispatch) {
    dispatch(setLoading({loading : true}));
}

export async function setLoadingHide(dispatch) {
    dispatch(setLoading({loading : false}));
}



export async function checkIsTokenValid() {
    const token = cookie.get('token');
    if(token){
return true;
        const redirectBackUrl = cookie.get('redirect_from');
        let config = {'headers': {"token": token, "lang": getLang()}};
        try {
            const reply = await axios.post(API_URL + '/isTokenValid', {url: (redirectBackUrl ?? window.location.href)}, config);
            if(reply.hasOwnProperty('data') && reply.data.hasOwnProperty('responseStatus') && reply.data.responseStatus === API_OK){
                if(reply.data.isTokenValid){
                    return true;
                }                     
            }
        } catch (e) {
            return false;
        }
    }
    return false;
}


export function getLang() {
    return cookie.get('lang');
}


export const translateObjectList = (list, name, t) => {
    let text = "";
    let first = true;
    if(list!=null) {
        list.map(value => {  
            text += (first?"":", ") + t(value[name]);
            first = false;
        })
    }
    return text;
}

export const translateList = (list, t) => {
    let text = "";
    let first = true;
    if(list!=null) {
        list.map(value => {  
            text += (first?"":", ") + t(value);
            first = false;
        })
    }
    return text;
  }


export const arrayBufferToBase64 = (buffer) => {
    if(typeof buffer === 'string' && buffer.startsWith('data:image')) {
        return buffer;
    }
    // if(buffer.length === 1) {
    //     return buffer[0];
    // }
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    let base64String = window.btoa(binary);
    return `data:image/png;base64,${base64String}`;
};


export const navigateTo = (dispatch, navigate, to, index=0) => {
    navigate(to);
    dispatch(setNavIndex({navIndex: index}));
}
